import { api } from "@/lib/api";

export const createInvitation = (body) => api.post("/invitations", body).then((r) => r.data);
export const listInvitations = () => api.get("/invitations").then((r) => r.data);
export const reissueInvitation = (id) => api.post(`/invitations/${id}/reissue`).then((r) => r.data);
export const revokeInvitation = (id) => api.post(`/invitations/${id}/revoke`).then((r) => r.data);
export const openInvitation = (token) => api.get(`/public/invitations/${token}`).then((r) => r.data);
export const startInvitation = (token, body) => api.post(`/public/invitations/${token}/start`, body).then((r) => r.data);
export const bulkInvitations = (ids, action, testOnly = false) => api.post("/invitations/bulk", { ids, action, test_only: testOnly }).then((r) => r.data);
export const claimInvitation = (token) => api.post(`/invitations/claim/${token}`).then((r) => r.data);

export const INVITE_STAGE = {
  created: ["Invitation Created", "bg-stone-50 text-stone-700 border-stone-200"],
  opened: ["Invitation Opened", "bg-sky-50 text-sky-800 border-sky-200"],
  email_sent: ["Verifying Email", "bg-sky-50 text-sky-800 border-sky-200"],
  contract_in_progress: ["Contract In Progress", "bg-amber-50 text-amber-800 border-amber-200"],
  contract_signed: ["Contract Signed", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  ad_template_in_progress: ["Ad Template In Progress", "bg-amber-50 text-amber-800 border-amber-200"],
  submitted: ["Submitted for Review", "bg-violet-50 text-violet-800 border-violet-200"],
  changes_requested: ["Changes Requested", "bg-orange-50 text-orange-800 border-orange-200"],
  ad_approved: ["Ad Approved", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  revoked: ["Revoked", "bg-red-50 text-red-700 border-red-200"],
  expired: ["Expired", "bg-stone-100 text-stone-500 border-stone-200"],
};
